import baseMixin from './baseMixin'
import { tween } from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'data-science-graphic'
    },

    methods: {
        setStyler() {
            this.stylers = this.stylerGroup('#ds-lines > path')
        },

        initAction() {
            return tween({ from: 100, to: 0 })
        },

        animationAction() {
            return tween({ to: 100, duration: 1500 })
        },

        initReaction(v) {
            this.stylers.forEach(styler => styler.set({ pathLength: v }))
        },

        animationReaction(v) {
            this.initReaction(v)
        }
    }
}
